module.exports = __webpack_public_path__ + "img/logo-sm.423359ba.png";